import React from 'react';
import '../../styles/Membership.css';
import '../../styles/ExclusiveOffers.css';

export default function ExclusiveOffers() {
  return (
    <div className='MemberShipContainer'>
        <div className='exclusive-offers-hero' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/comittee_banner.jpg'})`}}>
            <div className='exclusive-offers-hero-overlay'>
                <div className='exclusive-offers-hero-content'>
                    <div className='exclusive-offers-badge'>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        Member Benefits
                    </div>
                    <h1 className='exclusive-offers-hero-title'>
                        Exclusive Offers for <span className='exclusive-offers-highlight'>CANTO Members</span>
                    </h1>
                    <p className='exclusive-offers-hero-subtitle'>
                        Unlock premium discounts and value-added services from our trusted partners
                    </p>
                    <div className='exclusive-offers-hero-features'>
                        <div className='exclusive-offers-feature-item'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            <span>Exclusive Discounts</span>
                        </div>
                        <div className='exclusive-offers-feature-item'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            <span>Strategic Partnerships</span>
                        </div>
                        <div className='exclusive-offers-feature-item'>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            <span>Value-Added Services</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div style={{padding: '0 100px', margin: '60px 0'}}>
            <div style={{marginBottom: '40px', fontSize: '18px', lineHeight: '1.8', color: '#333'}}>
                Through our trusted partners and strategic alliances, members gain access to exclusive discounts, promotions, and value-added services designed to support your business and enhance your experience. Check back regularly for the latest offers.
            </div>

            <div className='MembershipCatTable'>
                <div className='MembershipCatTableTitle'>Current Offers</div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst' style={{width: '100%'}}>
                        <a href='https://ecocanto.ecomlac.lat' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'none', display: 'block'}}>
                            <img 
                                src={process.env.PUBLIC_URL + '/assets/offers/ecomlac_banner.png'} 
                                alt='Ecomlac Offer' 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </a>
                    </div>
                </div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst' style={{width: '100%'}}>
                        <a href='https://ta.uxi.re/6dGQL' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'none', display: 'block'}}>
                            <img 
                                src={process.env.PUBLIC_URL + '/assets/offers/Ticon.png'} 
                                alt='Ticon Offer' 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </a>
                    </div>
                </div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst' style={{width: '100%'}}>
                        <a href='https://mvno-index.com/' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'none', display: 'block'}}>
                            <img 
                                src={process.env.PUBLIC_URL + '/assets/offers/MVNO_Website_Banner.png'} 
                                alt='MVNO Offer' 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </a>
                    </div>
                </div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst' style={{width: '100%'}}>
                        <a href='https://www.ocbn.org/?utm_source=chatgpt.com' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'none', display: 'block'}}>
                            <img 
                                src={process.env.PUBLIC_URL + '/assets/offers/OCBN.jpg'} 
                                alt='OCBN Offer' 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </a>
                    </div>
                </div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst' style={{width: '100%'}}>
                        <a href='https://www.waldenu.edu/partners/CANTO?comm_code=4324303' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'none', display: 'block'}}>
                            <img 
                                src={process.env.PUBLIC_URL + '/assets/offers/Walden.png'} 
                                alt='Walden University Offer' 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </a>
                    </div>
                </div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst' style={{width: '100%'}}>
                        <a href='https://caribbeandatacenters.com/become-a-member/' target='_blank' rel='noopener noreferrer' style={{textDecoration: 'none', display: 'block'}}>
                            <img 
                                src={process.env.PUBLIC_URL + '/assets/offers/cda_banner.png'} 
                                alt='CDA Offer' 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s ease',
                                }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
  )
}
